import { Button, Input, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, Switch, useDisclosure } from "@nextui-org/react";
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { PencilSquareIcon } from "@heroicons/react/24/outline";
import toast from "react-hot-toast";
import { yupResolver } from "@hookform/resolvers/yup";
import { patchFetcher } from "../../../../../services/api";
import ControlledInput from "../../../../elements/ControlledInput";
import { month } from "../../../../../enums/month";
import ControlledReactQuill from "../../../../elements/ControlledReactQuill";
import { reportProductionValidation } from "../../../../../services/validation/report-production.validation";

export default function ModalEditProduction({ data, mutate }) {
  const [isExistReport, setIsExistReport] = useState(true);
  const {
    register,
    control,
    setValue,
    handleSubmit,
    reset,
    formState: { isSubmitting, dirtyFields },
  } = useForm({ resolver: yupResolver(reportProductionValidation) });
  const { isOpen, onOpenChange, onClose } = useDisclosure();

  function handleOnClose() {
    reset({
      laporanTersedia: setIsExistReport(true),
      jumlahB3Dihasilkan: "",
      prosesProduksi: "",
    });
    onClose();
  }

  function existReport(val) {
    setIsExistReport(val);
    setValue("jumlahB3Dihasilkan", 0);
    setValue("prosesProduksi", undefined);
  }

  function handleOnOpen() {
    reset({
      laporanTersedia: setIsExistReport(data?.laporanTersedia),
      jumlahB3Dihasilkan: data?.jumlahB3Dihasilkan,
      prosesProduksi: data?.prosesProduksi,
    });
    onOpenChange();
  }

  async function handleOnSubmit(formData) {
    try {
      await patchFetcher(`/api/pelaporan-b3-dihasilkan/update`, data?.id, formData);
      mutate();
      toast.success("Laporan bahan b3 berhasil diubah!");
      handleOnClose();
    } catch (error) {
      toast.error("Gagal ubah laporan bahan b3!");
    }
  }

  return (
    <>
      <Button size="sm" onPress={handleOnOpen} color="warning" isIconOnly>
        <PencilSquareIcon className="size-4" />
      </Button>
      <Modal size="2xl" isOpen={isOpen} onOpenChange={onOpenChange} onClose={handleOnClose} isDismissable={false} isKeyboardDismissDisabled={false}>
        <ModalContent>
          {(onClose) => (
            <form onSubmit={handleSubmit(handleOnSubmit)}>
              <ModalHeader className="flex flex-col gap-1">Ubah Produksi Jenis B3</ModalHeader>
              <ModalBody className="flex flex-col gap-3">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                  <Input isRequired isDisabled label="Perusahaan" value={data?.company?.name} labelPlacement="outside" variant="faded" />
                  <Input isRequired isDisabled label="Periode" value={data?.period?.name} labelPlacement="outside" variant="faded" />
                  <Input isRequired isDisabled label="Bulan" value={month[data?.bulan - 1]} labelPlacement="outside" variant="faded" />
                  <Input isRequired isDisabled label="Tahun" value={data?.tahun} labelPlacement="outside" variant="faded" />
                  <Input isRequired isDisabled label="Tipe Produk" value={data?.tipeProduk} labelPlacement="outside" variant="faded" />
                  {data?.tipeProduk === "Bahan Berbahaya dan Beracun" ? (
                    <Input isRequired isDisabled label="Jenis B3" value={`${data?.dataBahanB3?.casNumber} - ${data?.dataBahanB3?.namaBahanKimia}`} labelPlacement="outside" variant="faded" />
                  ) : (
                    <Input isRequired isDisabled label="Nama Produk" value={data?.namaProduk} labelPlacement="outside" variant="faded" />
                  )}
                </div>
                <Switch
                  {...register("laporanTersedia", {
                    onChange: (e) => {
                      existReport(e.target.checked);
                    },
                  })}
                  size="sm"
                  isSelected={isExistReport}
                >
                  {isExistReport ? "Laporan Tersedia" : "Tidak ada laporan produksi"}
                </Switch>
                {isExistReport && (
                  <>
                    <ControlledInput control={control} label="Jumlah Produksi (kg)" name="jumlahB3Dihasilkan" type="number" isRequired={true} />
                    {/* <ControlledReactQuill required={false} control={control} label="Proses Produksi" name="prosesProduksi" /> */}
                  </>
                )}
              </ModalBody>
              <ModalFooter>
                <Button isDisabled={isSubmitting} color="danger" variant="light" onPress={onClose}>
                  Tutup
                </Button>
                <Button isLoading={isSubmitting} isDisabled={isSubmitting || Object.keys(dirtyFields).length === 0} type="submit" color="primary">
                  Simpan
                </Button>
              </ModalFooter>
            </form>
          )}
        </ModalContent>
      </Modal>
    </>
  );
}
